/*
*###############################################################################
*Module Name                   : TransactionAttach.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, October 14th 2021, 10:08:19 am      #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React from "react"
import { Row } from "reactstrap"

import CommonFileUpload from "framework/common/CommonFileUpload"

const TransactionAttach = ({
    selectedAttachFiles,
    setSelectedAttachFiles,
    attachFileNames,
    setAttachFileNames,
    clearStatus,
    disable,
    clearAttachmentEdit
}) => {

    return (<Row>
        <CommonFileUpload
            selectedAttachFiles={selectedAttachFiles}
            setAttachFileNames={setAttachFileNames}
            attachFileNames={attachFileNames}
            setSelectedAttachFiles={setSelectedAttachFiles}
            clearStatus={clearStatus}
            disable={disable}
            clearAttachmentEdit={clearAttachmentEdit}
        />
    </Row>)

}
export default TransactionAttach
